<div>
	<h3>
		Region {{ lstStudentCommunicationEvent[0].studentCommunicationEvent.REGION.CODE }} -
		{{lstStudentCommunicationEvent[0].studentCommunicationEvent.REGION.NAME}}
	</h3>
</div>

<div class="table-responsive" *ngIf="dataSource.data.length > 0">
	<mat-table [dataSource]="dataSource" *ngIf="!editing">
		<ng-container [matColumnDef]="col.key" *ngFor="let col of columnsSchema">
			<mat-header-cell *matHeaderCellDef>
				<h4>{{ col.label }}</h4>
			</mat-header-cell>
			<mat-cell *matCellDef="let element">
				<div [ngSwitch]="col.key" class="row">
					<div *ngSwitchCase="'createdDate'" class="col">

						<div class="row">
							{{ element.studentCommunicationEvent?.CREATED_BY }}
						</div>
						<div class="row">
							{{ element.studentCommunicationEvent?.CREATED_DATE | simpleDate }}
						</div>

					</div>
					<div *ngSwitchCase="'updated'" class="col">
						<div class="row">{{ element.studentCommunicationEvent?.MODIFIED_BY }}</div>
						<div class="row">
							{{ element.studentCommunicationEvent?.MODIFIED_DATE | simpleDate }}
						</div>


					</div>
					<div *ngSwitchCase="'communicationDate'" class="col">
						{{ element.studentCommunicationEvent?.COMMUNICATION_DATE | simpleDate }}
					</div>
					<div *ngSwitchCase="'communicationType'" class="col">
						{{ element.studentCommunicationEvent?.COMMUNICATION_EVENT_PURPOSE_TYPES.TYPE }}
					</div>
					<div *ngSwitchCase="'comments'" class="col">
						<div class="row">
							<div class="col">
								<div class="padding-left-sm">
									{{ element.studentCommunicationEvent?.COMMENTS }}
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col">
								<hr
									class="element.studentCommunicationEvent?.STUDENT_COMMUNICATION_EVENT_PROPERTIES.length > 0" />
								<mat-checkbox disabled="true" [color]="'primary'"
									[checked]="element.studentCommunicationEvent?.STUDENT_COMMUNICATION_EVENT_PROPERTIES.length > 0">{{
									invokeDescription(element) }}</mat-checkbox>
							</div>
						</div>
					</div>
				</div>
			</mat-cell>
		</ng-container>
		<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
		<mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
	</mat-table>

	<mat-table [dataSource]="dataSource" *ngIf="editing">
		<ng-container [matColumnDef]="col.key" *ngFor="let col of columnsSchemaEdit">
			<mat-header-cell *matHeaderCellDef>
				<h4>{{ col.label }}</h4>
			</mat-header-cell>
			<mat-cell *matCellDef="let element">
				<div *ngIf="element.isEdit == false" [ngSwitch]="col.key" class="w-100">
					<div *ngSwitchCase="'isEdit'">
						<div *ngIf="editing">
							<button *ngIf="editAccess" mat-icon-button color="primary" (click)="editRow(element)">
								<mat-icon>edit</mat-icon>
							</button>
							<button *ngIf="editAccess" mat-icon-button color="warn"
								(click)="removeCommunicationEvent(element)">
								<mat-icon>delete</mat-icon>
							</button>
						</div>
					</div>

					<div *ngSwitchCase="'createdDate'">
						<div class="row">{{ element.studentCommunicationEvent?.CREATED_BY }}</div>
						<div class="row">
							{{ element.studentCommunicationEvent?.CREATED_DATE | simpleDate }}
						</div>
					</div>

					<div *ngSwitchCase="'updated'">
						<div class="row">
							<div class="col">{{ element.studentCommunicationEvent?.MODIFIED_BY }}</div>
							<div class="col">
								{{ element.studentCommunicationEvent?.MODIFIED_DATE | simpleDate }}
							</div>
						</div>
					</div>

					<div *ngSwitchCase="'communicationDate'">
						{{ element.studentCommunicationEvent?.COMMUNICATION_DATE | simpleDate }}
					</div>

					<div *ngSwitchCase="'communicationType'">
						{{ element.studentCommunicationEvent?.COMMUNICATION_EVENT_PURPOSE_TYPES.TYPE }}
					</div>

					<div *ngSwitchCase="'comments'">
						<div class="row">
							<div class="col">
								<div class="padding-left-sm">
									{{ element.studentCommunicationEvent?.COMMENTS }}
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col">
								<hr
									class="element.studentCommunicationEvent?.STUDENT_COMMUNICATION_EVENT_PROPERTIES.length > 0" />
								<mat-checkbox disabled="true" [color]="'primary'"
									[checked]="element.studentCommunicationEvent?.STUDENT_COMMUNICATION_EVENT_PROPERTIES.length > 0">{{
									invokeDescription(element) }}</mat-checkbox>
							</div>
						</div>
					</div>
				</div>

				<div *ngIf="element.isEdit == true && editing" [ngSwitch]="col.key" class="w-100">
					<div *ngSwitchCase="'isEdit'">
						<mat-icon *ngIf="isSaving">
							<mat-spinner *ngIf="isSaving" diameter="20"></mat-spinner>
						</mat-icon>

						<div *ngIf="element.isDelete == false && isSaving == false">
							<button mat-icon-button color="primary" (click)="updateRow(element)"
								[disabled]="disableSubmit(element)">
								<mat-icon>done</mat-icon>
							</button>
							<button mat-icon-button (click)="cancelRow(element)">
								<mat-icon>cancel</mat-icon>
							</button>
						</div>
						<div *ngIf="element.isDelete == true && isSaving == false">
							<button mat-icon-button color="warn" (click)="deleteRow(element)">
								<mat-icon>delete_forever</mat-icon>
							</button>
							<button mat-icon-button (click)="cancelRow(element)">
								<mat-icon>cancel</mat-icon>
							</button>
						</div>
					</div>

					<div *ngSwitchCase="'createdDate'">
						<div class="row">{{ element.studentCommunicationEvent?.CREATED_BY }}</div>
						<div class="row">
							{{ element.studentCommunicationEvent?.CREATED_DATE | simpleDate }}
						</div>
					</div>

					<div *ngSwitchCase="'updated'">
						<div class="row">{{ element.studentCommunicationEvent?.MODIFIED_BY }}</div>
						<div class="row">
							{{ element.studentCommunicationEvent?.MODIFIED_DATE | simpleDate }}
						</div>
					</div>

					<div *ngSwitchCase="'communicationDate'">
						<mat-form-field class="w-100">
							<input matInput [matDatepicker]="picker1"
								[(ngModel)]="element.studentCommunicationEvent.COMMUNICATION_DATE" />
							<mat-hint>MM/DD/YYYY</mat-hint>
							<mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
							<mat-datepicker #picker1></mat-datepicker>
						</mat-form-field>
					</div>

					<div *ngSwitchCase="'communicationType'">
						<mat-form-field class="w-100">
							<mat-select id="selCommunicationEventPurposeTypes" name="selCommunicationEventPurposeTypes"
								(selectionChange)="matSelectEventchanged(element)"
								[(ngModel)]="element.studentCommunicationEvent.COMMUNICATION_EVENT_PURPOSE_TYPES"
								[compareWith]="compareFn" required="true">
								<mat-option *ngFor="let type of communicationEventPurposeTypes" [value]="type">
									{{ type.TYPE }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>

					<div *ngSwitchCase="'comments'">
						<div class="row">
							<div class="col inline">
								<mat-form-field class="w-100">
									<textarea matInput
										[(ngModel)]="element.studentCommunicationEvent.COMMENTS"></textarea>
								</mat-form-field>
							</div>
						</div>
						<div class="row"
							*ngIf="element.studentCommunicationEvent?.COMMUNICATION_EVENT_PURPOSE_TYPES?.ID > 0">
							<div class="col">
								<mat-checkbox (change)="cEPPropertyTypes(element, $event)" [color]="'primary'"
									[checked]="element.studentCommunicationEvent?.STUDENT_COMMUNICATION_EVENT_PROPERTIES.length > 0">{{
									invokeDescription(element) }}</mat-checkbox>
							</div>
						</div>
					</div>
				</div>
			</mat-cell>
		</ng-container>
		<mat-header-row *matHeaderRowDef="displayedColumnsEdit"></mat-header-row>
		<mat-row *matRowDef="let row; columns: displayedColumnsEdit"></mat-row>
	</mat-table>

	<mat-paginator [length]="dataSource.data.length" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
		aria-label="Select page of periodic elements"></mat-paginator>
</div>